import { render, staticRenderFns } from "./CompanyDefaultStats.vue?vue&type=template&id=1511ef9e&scoped=true"
import script from "./CompanyDefaultStats.vue?vue&type=script&lang=js"
export * from "./CompanyDefaultStats.vue?vue&type=script&lang=js"
import style0 from "./CompanyDefaultStats.vue?vue&type=style&index=0&id=1511ef9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1511ef9e",
  null
  
)

export default component.exports